import React from 'react';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { getAppPermissionsState } from '../../../common/store/comments/comments-permissions';
import { useApi } from '../../context/api-context/use-api';
import CommentList from '../comment-list/comment-list';
import { useListFitsToScreen } from '../comment-list/use-list-fits-to-screen';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import StartRootBoxSection from '../root-box-sections/start-root-box-section';
import EndRootBoxSection from '../root-box-sections/end-root-box-section';
import RootBoxEffectProvider from '../../context/root-box-effect-context/root-box-effect-provider';
import { PermissionsProvider } from '../../context/permissions-context/permissions-provider';
import { useModalEffect } from './use-modal-effect';
const AppReady = ({ listState, appHeaderIsVisible }) => {
    useModalEffect();
    const { resourceId, isLocked, isPreconditionRequiredForAction, commentsCreation, repliesCreation, reactionsCreation, disableWriteBeforeLogin, commentBoxPosition, hideSorting, ctxFields, } = useConfiguration();
    const { fetchNextComments, fetchPrevComments, fetchNextReplies, fetchPrevReplies, currentOwner, isMobile, forceShowCommentBoxes, } = useApi((state, actions, _, ctx) => ({
        fetchNextComments: actions.fetchNextComments,
        fetchPrevComments: actions.fetchPrevComments,
        fetchNextReplies: actions.fetchNextReplies,
        fetchPrevReplies: actions.fetchPrevReplies,
        currentOwner: state.members.currentOwner,
        isMobile: getIsMobile(state),
        forceShowCommentBoxes: ctx.wcDevToolsState.forceShowCommentBoxes,
    }));
    const { listRef, listFitsToScreen } = useListFitsToScreen(resourceId, listState.commentList.length);
    const permissions = listState.type === 'READY' ? listState.permissions : null;
    const permissionsState = React.useMemo(() => getAppPermissionsState({
        isLocked,
        permissions: permissions,
        currentOwner,
        isPreconditionRequiredForAction,
        commentsCreation,
        repliesCreation,
        reactionsCreation,
        isWriteBeforeLoginDisabled: disableWriteBeforeLogin,
        srcResourceId: resourceId,
    }), [
        isLocked,
        permissions,
        currentOwner,
        isPreconditionRequiredForAction,
        commentsCreation,
        repliesCreation,
        reactionsCreation,
        disableWriteBeforeLogin,
        resourceId,
    ]);
    const commentBoxLayout = (() => {
        if (forceShowCommentBoxes) {
            return 'BOTH';
        }
        if (commentBoxPosition) {
            return commentBoxPosition === 'TOP_ONLY' ? 'TOP' : 'BOTTOM';
        }
        return listFitsToScreen ? 'TOP' : 'BOTH';
    })();
    const boxRating = React.useMemo(() => ({
        ...listState.ratings.inputRating,
        hasPrevious: !!listState.ratings.currentRating.value,
    }), [listState.ratings.inputRating, listState.ratings.currentRating.value]);
    return (React.createElement(PermissionsProvider, { permissionsState: permissionsState },
        React.createElement(RootBoxEffectProvider, { effectState: listState.commentBox },
            React.createElement(StartRootBoxSection, { isListEmpty: listState.isEmpty, someoneIsTyping: listState.someoneIsTyping, appHeaderIsVisible: appHeaderIsVisible, shouldShowCommentBox: commentBoxLayout !== 'BOTTOM', boxRating: boxRating, selectedSort: listState.ordering, hideSort: hideSorting || listState.isEmpty }),
            React.createElement(CommentList, { ref: listRef, fetchNextComments: () => fetchNextComments({ resourceId, ctxFields }), fetchPrevComments: () => fetchPrevComments({ resourceId, ctxFields }), fetchNextReplies: (commentId) => fetchNextReplies({ resourceId, commentId, ctxFields }), fetchPrevReplies: (commentId) => fetchPrevReplies({ resourceId, commentId, ctxFields }), state: listState, isMobile: isMobile, liveCommentsLayout: commentBoxLayout }),
            commentBoxLayout !== 'TOP' ? (React.createElement(EndRootBoxSection, { someoneIsTyping: listState.someoneIsTyping, boxRating: boxRating })) : null)));
};
AppReady.displayName = 'AppReady';
export default AppReady;
//# sourceMappingURL=app-ready.js.map